import { useTranslation } from 'react-i18next';
import * as backend from 'src/backend';

export const getRecipientOnboardingState = ({
  requiredItems = [],
  hasIncomingOnboardingRequest = false,
} = {}) => {
  const items = Array.isArray(requiredItems) ? requiredItems : [];
  const allCompliant =
    items.length > 0 && items.every((item) => item.is_marked_compliant);
  const anyCompleted = items.some((item) => item.completed !== null);
  const hasOnboardingRequest = items.some(
    (item) => item.has_onboarding_request
  );
  const isAssignable = items.length === 0 || allCompliant || anyCompleted;

  return {
    isAssignable,
    isPending: items.length > 0 && !isAssignable,
    requiresOnboarding: items.length > 0,
    hasOnboardingRequest,
    hasIncomingOnboardingRequest: Boolean(hasIncomingOnboardingRequest),
  };
};

export const shouldValidateDonorOnboarding = ({
  donorTeamId,
  existingDonorTeamId,
  isFoodRun,
}) =>
  Boolean(isFoodRun) &&
  Boolean(donorTeamId) &&
  donorTeamId !== 'unassigned' &&
  donorTeamId !== existingDonorTeamId;

const useCheckCompletedOnboarding = () => {
  const { t } = useTranslation('translation');

  const buildErrorMessage = (npos, receiver) =>
    t('donations.must-complete-onboarding-items', {
      name: npos.find((team) => team.team_id === receiver)?.name ?? '',
    });

  const validate = async (receiver, onboardingState = null) => {
    if (!receiver || receiver === 'unassigned') {
      return true;
    }
    if (onboardingState) {
      return onboardingState.isAssignable;
    }

    const requiredItems =
      await backend.team.getItemsRequiredToDonateTo(receiver);
    return getRecipientOnboardingState({ requiredItems }).isAssignable;
  };

  return {
    buildErrorMessage,
    validate,
  };
};

export default useCheckCompletedOnboarding;
